import { distanceTo } from 'geolocation-utils';
import React from 'react';
import { useTabState } from '@bumaga/tabs';
import L from 'leaflet';
import PoiMarker from '../components/MapPanel/markers/poi/PoiMarker';

export const findLocationDistGaps = locationsArray => {
  let prevPoint = null;
  const pointsPairs = [];
  locationsArray.forEach(point => {
    if (prevPoint != null) {
      const dist = distanceTo(
        [prevPoint.e_pos_lat, prevPoint.e_pos_long],
        [point.e_pos_lat, point.e_pos_long]
      );
      if (dist / 1000 > 10) {
        pointsPairs.push({
          distance: dist / 1000,
          from: prevPoint,
          to: point
        });
      }
    }
    prevPoint = point;
  });
  localStorage.setItem('dists', JSON.stringify(pointsPairs));
};

export const calculateTraversedDistance = traversedStages => {
  let prevPoint = null;
  let calcDist = 0;
  traversedStages.forEach(point => {
    if (prevPoint != null) {
      calcDist += distanceTo(prevPoint, point);
    }
    prevPoint = point;
  });
  return calcDist;
};

export const selectIcon = item => {
  switch (item) {
    case 'RELAY_CHANGE':
      return 'relay-change.svg';
    case 'RR_TRACK':
      return 'rnr.svg';
    case 'ACCOMMODATION':
      return 'accomodation.svg';
    case 'FOOD':
      return 'foodie.svg';
    case 'VIEW':
      return 'view.svg';
    case 'RELAX':
      return 'relax.svg';
    case 'MONUMENT':
      return 'monument.svg';
    case 'BEACH':
      return 'beach.svg';
    case 'SERVICE_STATION':
      return 'service-station.svg';
    case 'CLIMB':
      return 'mountain.svg';
    case 'COFFEE':
      return 'coffee.svg';
    case 'TEMPLE':
      return 'church.svg';
    case 'MARKET':
      return 'market.svg';
    case 'WEATHER':
    default:
      return 'weather.svg';
  }
};

export const degToCard = deg => {
  if (deg > 11.25 && deg < 33.75) {
    return 'NNE';
  } else if (deg > 33.75 && deg < 56.25) {
    return 'ENE';
  } else if (deg > 56.25 && deg < 78.75) {
    return 'E';
  } else if (deg > 78.75 && deg < 101.25) {
    return 'ESE';
  } else if (deg > 101.25 && deg < 123.75) {
    return 'ESE';
  } else if (deg > 123.75 && deg < 146.25) {
    return 'SE';
  } else if (deg > 146.25 && deg < 168.75) {
    return 'SSE';
  } else if (deg > 168.75 && deg < 191.25) {
    return 'S';
  } else if (deg > 191.25 && deg < 213.75) {
    return 'SSW';
  } else if (deg > 213.75 && deg < 236.25) {
    return 'SW';
  } else if (deg > 236.25 && deg < 258.75) {
    return 'WSW';
  } else if (deg > 258.75 && deg < 281.25) {
    return 'W';
  } else if (deg > 281.25 && deg < 303.75) {
    return 'WNW';
  } else if (deg > 303.75 && deg < 326.25) {
    return 'NW';
  } else if (deg > 326.25 && deg < 348.75) {
    return 'NNW';
  } else {
    return 'N';
  }
};

export const cn = (...args) => args.filter(Boolean).join(' ');
export const Tab = ({ children }) => {
  const { isActive, onClick } = useTabState();

  return (
    <button className={cn('tab', isActive && 'active')} onClick={onClick}>
      {children}
    </button>
  );
};

export const createIcon = poiData => {
  const icon = selectIcon(poiData.info.value);
  return new L.Icon({
    iconUrl: require(`../assets/images/${icon}`),
    iconRetinaUrl: require(`../assets/images/${icon}`),
    iconSize: [40, 40]
  });
};

export const generateMarkerPoints = (
  posts,
  setMarkers,
  setImages,
  setIsOpenImageBox,
  setIsPopupOpen
) => {
  let markers = [];
  posts.forEach(item => {
    markers.push(
      <PoiMarker
        key={`${item.info.id}`}
        item={item}
        setters={{ setImages, setIsOpenImageBox, setIsPopupOpen }}
      ></PoiMarker>
    );
  });
  setMarkers(markers);
};
